// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || '';

export const USER_GLOBAL_HOST_API_KEY = process.env.REACT_APP_USER_GLOBAL_HOST_API_KEY || '';

export const PARTNER_ONBOARDING_URL = process.env.REACT_APP_PARTNER_ONBOARDING_URL || '';
export const COUPON_URL_API = process.env.REACT_APP_COUPON_API || '';
export const DISCOVERY_CALL_API = process.env.REACT_APP_DISCOVERY_CALL || '';

export const NODE_API_KEY = process.env.REACT_APP_NODE_API_KEY || '';

export const WHATSAPP_DEMO_API_KEY = process.env.REACT_APP_WHATSAPP_DEMO_API || '';

export const JAVASCRIPT_MIDDLEWARE_API_KEY = process.env.REACT_APP_JAVASCRIPT_MIDDLEWARE_API || '';

export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || '';
export const PARTNER_URL = process.env.REACT_APP_PARTNER_URL || '';
export const GMB_API_KEY = process.env.REACT_APP_GMB_API_KEY || '';

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAP_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.customers.root;

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 80,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const FOOTER = {
  // Fixed "Powered by" bar at the bottom of the vertical dashboard layout.
  // The permanent sidebar reserves this much space so nothing hides behind it.
  H_DASHBOARD: 40,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
